module.exports = __webpack_public_path__ + "img/seanbackpiece3.6fdd39c8.jpg";